/*
 * Dinowax video facades.
 *
 * The Replo page mounted three live YouTube iframes on load — roughly a
 * megabyte of third-party JavaScript and several extra connections before the
 * visitor had clicked anything. Here each video is a poster image plus a play
 * button, and the iframe is only created on click. Nothing from YouTube is
 * requested until someone actually wants to watch.
 *
 * Also handles the "view more" reveal, so extra videos can live on the page
 * (crawlable, in the DOM) without all of them being visible at once.
 */
(function () {
  'use strict';

  if (window.DWVideo) { window.DWVideo.init(); return; }

  function play(facade) {
    var id = facade.getAttribute('data-dw-video');
    if (!id) return;

    var params = facade.getAttribute('data-dw-video-params') || '';
    var iframe = document.createElement('iframe');
    /* nocookie: no YouTube cookie is set unless the visitor presses play. */
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
                 '?autoplay=1&rel=0' + (params ? '&' + params : '');
    iframe.title = facade.getAttribute('data-dw-video-title') || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; ' +
                   'gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    iframe.className = 'dw-video__iframe';

    facade.replaceWith(iframe);
    iframe.focus();
  }

  function initFacades(root) {
    var nodes = root.querySelectorAll('[data-dw-video]:not([data-dw-video-ready])');
    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-dw-video-ready', 'true');
      el.addEventListener('click', function () { play(el); });

      /* Not every upload has a maxresdefault thumbnail. YouTube does not 404
         for the missing ones — it serves a 120x90 grey placeholder with a 200 —
         so an error handler alone never fires. Detect it by natural size and
         swap to hqdefault, which always exists. */
      var img = el.querySelector('img[data-dw-video-poster]');
      if (img) {
        var swap = function () {
          var fallback = img.getAttribute('data-dw-video-poster-fallback');
          if (!fallback || img.src === fallback) return;
          img.src = fallback;
        };
        var check = function () {
          if (img.naturalWidth && img.naturalWidth <= danger) swap();
        };
        var danger = 200;
        img.addEventListener('error', swap);
        if (img.complete) check();
        else img.addEventListener('load', check);
      }
    });
  }

  function initMore(root) {
    var buttons = root.querySelectorAll('[data-dw-video-more]:not([data-dw-video-more-ready])');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.setAttribute('data-dw-video-more-ready', 'true');
      btn.addEventListener('click', function () {
        var scope = btn.closest('[data-dw-video-scope]') || document;
        var hidden = scope.querySelectorAll('[data-dw-video-hidden]');
        Array.prototype.forEach.call(hidden, function (el) {
          el.removeAttribute('data-dw-video-hidden');
        });
        if (hidden.length) {
          hidden[0].querySelector('a, button, iframe, [tabindex]')?.focus();
        }
        btn.hidden = true;
      });
    });
  }

  var DWVideo = {
    init: function (scope) {
      var root = scope || document;
      initFacades(root);
      initMore(root);
    }
  };

  window.DWVideo = DWVideo;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { DWVideo.init(); });
  } else {
    DWVideo.init();
  }

  document.addEventListener('shopify:section:load', function (e) { DWVideo.init(e.target); });
})();
